<template>
<div class="packet">
  <van-popup v-model="showPacket" class="popup"  :close-on-click-overlay="false" @click-overlay="showPacket=false">
    <div class="popup-wrap">
      <div class="popup-content"  @click="lotteryClick">
          <div class="popup-text">成功选择队伍<br/>获得一次抽奖机会</div>
          <button class="packet-btn" >立即抽奖</button>
          <div class="tip">有机会获得以下奖品</div>
          <img src="../../img/list.png" alt="">
      </div>
    </div>
    <div @click="close" class="popup-close"></div>
  </van-popup>
  <van-popup v-model="showLottery" class="popup" @click-overlay="handlerClosePacket">
     <div class="popup-title">{{prize.type=='thanks'?'很遗憾，您未中奖!':'哇，恭喜你获得'}} </div>
      <div class="open-packet">
        <div class="rp" v-if="prize.type=='rp'">
           <div class="money"><span>{{prize.value}}</span>元</div>
           <div class="tip">（红包可用于线上线下消费抵扣）</div>
        </div>
        <div class="no-draw"  v-else-if="prize.type=='thanks'">什么都没捞到<br/>再试试手气~</div>
        <div class="link" v-else>
          <div class="link-name"> {{ prize.name }}</div>
        </div>
        <button class="packet-btn" v-if="prize.type=='thanks'" @click="handlerClosePacket">知道了</button>
        <button class="packet-btn" v-else  @click="jumpCard">立即领取</button>
        <div class="packet-foot" v-for="(item,index) in $state.couponList"  @click="$receiveCoupon(item,0)">
          <div class="ad-img">
            <img :src="$state.brandInfo.ad_img_2" alt="">
          </div>
          <div class="right">
            <img class="get" v-if="!item.is_client" src="../../img/get.png" alt="">
            <img class="got" v-else src="../../img/got.png" alt="">
          </div>
        </div>
      </div>
      <div @click="handlerClosePacket" class="popup-close"></div>
  </van-popup>
</div>
</template>
<script>
import {
  openLottery
} from '../../mixins/functions'
export default {
  name: 'packet',
  data() {
    return {
      showPacket:false,
      showLottery:false,
      cnum:'',
      prize:{},
      ad:''
    }
  },
  methods: {
    openPacket(cnum){
      this.showPacket = true
      this.cnum = cnum
    },
    handlerClosePacket(){
      this.showLottery = false
    },
    handlerOpenPacket(item){
      this.showLottery = true
      this.prize = item
    },
    close(){
      this.showPacket = false
    },
    jumpCard(){
      if (this.prize.link) {
        ap.pushWindow(this.prize.link)
        // ap.onResume(() => {
        //   ap.offResume()
        //   this.handlerClosePacket()
        // })
      }
    },
    async lotteryClick(){
      const res = await openLottery.call(this,this.cnum)
      if(res.code === 0){
        this.showPacket = false
        this.showLottery = true
        this.prize=res.data
      }else{
        this.$toast(res.msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-title{
  font-size: 40px;
  text-align: center;
  color:#ffdb58;
  margin-bottom: 20px;
}
.popup-content{
  background:  #b71f2a;
  border:4px solid #ea202e;
  border-radius: 25px;
  text-align: center;
  padding: 50px;
  .popup-text{
    color:#fff;
    font-size: 36px;
  }
  img{
    width:536px;
    height: 323px;
  }
  .tip{
    color:#ff8991;
    margin:45px auto 35px;
  }
  button{
    width:400px;
    height:90px;
    line-height: 90px;
    border-radius: 45px;
    background: linear-gradient(#fef061,#fa8306);
    color:#e43535;
    font-size: 40px;
    border:0;
    margin:40px  auto;
    display: block;
    box-shadow: 0 10px 10px #a3111a;
  }
}
.open-packet{
  width:684px;
  height:679px;
  position: relative;
  background: url(../../img/packet.png) center/contain no-repeat;
  .no-draw{
    width:490px;
    height:245px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin:0 auto;
    font-size: 40px;
    text-align: center;
  }
  .link{
    width:490px;
    height:245px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    margin:0 auto;
    font-size: 40px;
    color:#444;
    .link-name{
        font-size: 40px;
    }
  }
  .rp{
    width:490px;
    height:245px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin:0 auto;
    .money{
      font-size: 40px;
      color:#fd4b3f;
      span{
        font-size: 100px;
        font-weight: bolder;
      }
    }
    .tip{
      color:#514a31;
      font-size: 28px;
    }
  }
  .packet-btn{
    width:400px;
    height:90px;
    line-height: 90px;
    border-radius: 45px;
    background: linear-gradient(#fef061,#fa8306);
    color:#e43535;
    font-size: 40px;
    border:0;
    margin:80px auto 0;
    display: block;
    box-shadow: 0 10px 10px #e73735;
  }
}
.packet-foot{
  height:200px;
  position: absolute;
  width:595px;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  background: linear-gradient(#ff9031,#ff6d2e);
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  align-items: center;
  .ad-img{
    img{
      width:100%;
      border-bottom-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .right{
    position: absolute;
    top:80px;
    right:20px;
    img{
      width:110px;
    }
  }

}
</style>
